import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import { productsApi } from './productsApi';
import { categoriesApi } from './categoriesApi';
import { logsApi } from './logsApi';
import { statsApi } from './statsApi';
import newProductReducer from './newProductSlice';

const STORAGE_KEY = 'aye-auth';

export const store = configureStore({
  reducer: {
    auth:                        authReducer,
    newProduct:                  newProductReducer,
    [productsApi.reducerPath]:   productsApi.reducer,
    [categoriesApi.reducerPath]: categoriesApi.reducer,
    [logsApi.reducerPath]:       logsApi.reducer,
    [statsApi.reducerPath]:      statsApi.reducer,
  },
  middleware: (getDefault) =>
    getDefault()
      .concat(productsApi.middleware)
      .concat(categoriesApi.middleware)
      .concat(logsApi.middleware)
      .concat(statsApi.middleware),
});

// Persist auth to localStorage on every change
store.subscribe(() => {
  const { auth } = store.getState();
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ token: auth.token, user: auth.user }));
  } catch { /* ignore quota errors */ }
});

export type RootState   = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
